import { render, staticRenderFns } from "./VacationRegistrations.vue?vue&type=template&id=c2d24ab0&scoped=true&"
import script from "./VacationRegistrations.vue?vue&type=script&lang=js&"
export * from "./VacationRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./VacationRegistrations.vue?vue&type=style&index=0&id=c2d24ab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d24ab0",
  null
  
)

export default component.exports